export const BREADCRUMB_HOME = [
    {
        label: "Accueil",
        href: "/",
    },
];
